import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function trackPlausibleEvent(eventName, props) {
  if (typeof window !== "undefined" && typeof window.minutezillaAnalytics === "function") {
    window.minutezillaAnalytics(eventName, props);
  }
}

export function PlausibleAnalytics() {
  const location = useLocation();
  useEffect(() => {
    trackPlausibleEvent("pageview");
  }, [location.pathname, location.search]);
  return null;
}
